import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="bg-[#0D0D0D] p-4 md:p-6 animate-pulse" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {/* Back button skeleton */}
      <div className="flex items-center mb-6">
        <div className="w-6 h-6 bg-[rgba(51,51,51,0.5)] rounded-full mr-2"></div>
        <div className="h-6 bg-[rgba(51,51,51,0.5)] rounded-full w-32"></div>
      </div>

      {/* Main content area */}
      <div className="flex flex-col md:flex-row gap-6 mb-8">
        {/* Image placeholder */}
        <div className="w-full md:w-1/2">
          <div className="aspect-[4/3] bg-[rgba(51,51,51,0.5)] rounded-lg"></div>
        </div>

        {/* Event info placeholder */}
        <div className="w-full md:w-1/2 space-y-4">
          <div className="h-10 bg-[rgba(51,51,51,0.5)] rounded w-3/4"></div>
          <div className="h-8 bg-[rgba(51,51,51,0.5)] rounded w-1/2"></div>
          <div className="h-6 bg-[rgba(51,51,51,0.5)] rounded w-full"></div>
          <div className="h-6 bg-[rgba(51,51,51,0.5)] rounded w-5/6"></div>
          <div className="h-6 bg-[rgba(51,51,51,0.5)] rounded w-2/3"></div>
          
          {/* Scroll down button */}
          <div className="flex items-center pt-4">
            <div className="w-6 h-6 bg-[rgba(51,51,51,0.5)] rounded-full mr-2"></div>
            <div className="h-6 bg-[rgba(51,51,51,0.5)] rounded-full w-48"></div>
          </div>
        </div>
      </div>

      {/* Tags section */}
      <div className="flex flex-wrap gap-2 mb-8">
        <div className="h-8 bg-[rgba(45,45,45,0.5)] rounded-full w-24"></div>
        <div className="h-8 bg-[rgba(45,45,45,0.5)] rounded-full w-20"></div>
        <div className="h-8 bg-[rgba(45,45,45,0.5)] rounded-full w-28"></div>
      </div>

      {/* Event details section */}
      <div className="flex flex-col md:flex-row gap-8">
        {/* Text content */}
        <div className="w-full md:w-1/2 space-y-4">
          <div className="h-8 bg-[rgba(51,51,51,0.5)] rounded w-32 mb-6"></div>
          
          {/* Paragraph placeholders */}
          <div className="space-y-3">
            <div className="h-4 bg-[rgba(51,51,51,0.5)] rounded w-full"></div>
            <div className="h-4 bg-[rgba(51,51,51,0.5)] rounded w-5/6"></div>
            <div className="h-4 bg-[rgba(51,51,51,0.5)] rounded w-3/4"></div>
            <div className="h-4 bg-[rgba(51,51,51,0.5)] rounded w-full"></div>
            <div className="h-4 bg-[rgba(51,51,51,0.5)] rounded w-2/3"></div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col gap-3 pt-6">
            <div className="h-12 bg-[rgba(45,45,45,0.5)] rounded w-full md:w-64"></div>
          </div>
        </div>

        {/* Video placeholder */}
        <div className="w-full md:w-1/2">
          <div className="aspect-video bg-[rgba(51,51,51,0.5)] rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;